const REPLACEMENT_CHAR = "\uFFFD";

async function readBlobBytes(file: Blob): Promise<Uint8Array> {
  if (typeof file.arrayBuffer === "function") {
    return new Uint8Array(await file.arrayBuffer());
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error ?? new Error("Failed to read uploaded file"));
    reader.readAsArrayBuffer(file);
  });
}

function decodeWithEncoding(bytes: Uint8Array, encoding: string): string {
  return new TextDecoder(encoding).decode(bytes);
}

export async function decodePlainTextFile(file: Blob): Promise<string> {
  const bytes = await readBlobBytes(file);

  if (bytes.length >= 3 && bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    return decodeWithEncoding(bytes.subarray(3), "utf-8");
  }

  if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
    return decodeWithEncoding(bytes.subarray(2), "utf-16le");
  }

  if (bytes.length >= 2 && bytes[0] === 0xfe && bytes[1] === 0xff) {
    return decodeWithEncoding(bytes.subarray(2), "utf-16be");
  }

  const utf8 = decodeWithEncoding(bytes, "utf-8");
  if (!utf8.includes(REPLACEMENT_CHAR)) {
    return utf8;
  }

  try {
    return decodeWithEncoding(bytes, "windows-1252");
  } catch {
    return utf8;
  }
}
